import script from "./RegisterOrderModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisterOrderModal.vue?vue&type=script&setup=true&lang=ts"

import "./RegisterOrderModal.vue?vue&type=style&index=0&id=0976962d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0976962d"]])

export default __exports__